import { render, staticRenderFns } from "./BackProjectButton.vue?vue&type=template&id=1acb572d"
import script from "./BackProjectButton.vue?vue&type=script&lang=js"
export * from "./BackProjectButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports